const langInvestFundAssetsTable = {
	subtitle_periode_reporting: {
		tag: 'invest.fund_assets_table.subtitle_periode_reporting',
		fr: 'Période de reporting',
		en: 'Reporting period',
	},
	asset_name: {
		tag: 'invest.fund_assets_table.asset_name',
		fr: 'Nom',
		en: 'Name',
	},
	country_name: {
		tag: 'invest.fund_assets_table.country_name',
		fr: 'Pays',
		en: 'Country',
	},
	investment_date: {
		tag: 'invest.fund_assets_table.investment_date',
		fr: "Date de l'investissement",
		en: 'Investment date',
	},
	asset_maturity_date: {
		tag: 'invest.fund_assets_table.asset_maturity_date',
		fr: 'Date de maturité',
		en: 'Maturity date',
	},
	contributed_capital: {
		tag: 'invest.fund_assets_table.contributed_capital',
		fr: 'Encours déployé',
		en: 'Contributed capital',
	},
	outstanding_capital: {
		tag: 'invest.fund_assets_table.outstanding_capital',
		fr: 'CRD',
		en: 'Outstanding capital',
	},
};

export default langInvestFundAssetsTable;
